<template>
  <div>
    <slot></slot>
    <a
      class="made-with-grouper"
      title="Open source self-hosted no-code platform"
      @click="handleMadeWithGrouperClick"
    >
      Made with
      <img
        src="@grouper_enterprise/assets/images/builder/mini_logo.svg?url"
        alt="Grouper"
      />
    </a>

    <PaidFeaturesModal
      ref="paidFeaturesModal"
      :initial-selected-type="paidFeatureType"
    ></PaidFeaturesModal>
  </div>
</template>

<script>
import PaidFeaturesModal from '@grouper_premium/components/PaidFeaturesModal'
import { BuilderBrandingPaidFeature } from '@grouper_enterprise/paidFeatures'

export default {
  components: {
    PaidFeaturesModal,
  },
  props: {
    showPaidFeaturesModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    paidFeatureType() {
      return BuilderBrandingPaidFeature.getType()
    },
  },
  methods: {
    handleMadeWithGrouperClick(event) {
      if (this.showPaidFeaturesModal) {
        event.preventDefault()
        this.$refs.paidFeaturesModal.show()
      }
    },
  },
}
</script>
